import React from 'react'

const MobileFiltersDiscount = () => {
	return (
		<div>
			<div>
				<div className='mb-3'>
					<h5 className='text-normal text-black'>Discounts</h5>
				</div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						0 - 20% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						21 - 30% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						31 - 40% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						41 - 50% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						51 - 70% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						71 - 90% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						91 - 100% <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
		</div>
	)
}

export default MobileFiltersDiscount
